class FormFileUpload {
    // 1. describe and create/initiate our object
    constructor() {
        this.uploadContent = document.querySelector('.form-file-upload-content');
        this.uploadInput = document.querySelector('.take-part input.wpcf7-file');
        this.defaultIcon = this.uploadContent.querySelector('.form-file-upload-content--icon').innerHTML;
        this.defaultText = this.uploadContent.querySelector('.form-file-upload-content--text').innerHTML;
        this.checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-checkbox" width="48" height="48" viewBox="0 0 24 24" stroke-width="1.5" stroke="#8B7657" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 11l3 3l8 -8"/><path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"/></svg>`;

        if (this.uploadContent && this.uploadInput && this.defaultIcon && this.defaultText) {
            this.events();
        }
    }

    // 2. events
    events() {
        var inputText = this.uploadContent.querySelector('.form-file-upload-content--text');
        var inputIcon = this.uploadContent.querySelector('.form-file-upload-content--icon');
        var grayText = document.querySelector('.form-file-upload .form-gray-text');
        var grayTextDefault = grayText.innerHTML;
        this.uploadInput.addEventListener('change', () => {
            if (this.uploadInput.files.length > 0) {
                var rawFileSize = this.uploadInput.files[0].size / 1024;
                var fileSize = rawFileSize.toFixed(1);

                if (inputText && inputIcon) {
                    inputText.innerHTML = 'dziękujemy za przesłanie zdjęcia';
                    inputIcon.innerHTML = this.checkIcon;
                }
                if(grayText) {
                    grayText.innerHTML = `${this.uploadInput.files[0].name}, ${fileSize} KB`
                }
            }
            else {
                if (inputText && inputIcon) {
                    inputText.innerHTML = this.defaultText;
                    inputIcon.innerHTML = this.defaultIcon;
                }
                if(grayText) {
                    grayText.innerHTML = grayTextDefault;
                }
            }
        });
    }

}

export default FormFileUpload;
